import type { IBrands } from "../../../../brands/hooks/http/colab/workspace/get-workspace.hook";
import type { IUser } from "../../../../types/models/user.models.types";
import { usePostHttp } from "../../http.hook";

interface IResponse {
  user: IUser;
  brands: Array<IBrands>;
}

export function useDashboardConfigCommonHttp() {
  return usePostHttp<null, IResponse>({
    path: "/common/users/dashboard-config",
  });
}
